module.exports = __webpack_public_path__ + "static/media/masphliquido.7f956669.pdf";